var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnimals(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.15051 17.4779C7.0356 17.1181 6.99118 16.7864 7.00143 16.4815C7.0832 14.0477 9.54341 11 11.9786 11C14.3669 11 16.612 14.0493 16.9738 16.4101C17.0244 16.7399 17.0047 17.0962 16.8892 17.4779C16.8809 17.5053 16.8722 17.5323 16.8632 17.5589C15.7246 20.9179 8.31255 20.894 7.16979 17.5363C7.16324 17.5171 7.15681 17.4976 7.15051 17.4779Z",
    stroke: "#BF9A6D",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.94245 10.3818C6.39495 11.769 5.8043 12.944 5.03333 13.2327C4.26237 13.5214 3.1172 12.9964 2.66471 11.6091C2.21221 10.2219 2.80286 9.04691 3.57383 8.75823C4.34479 8.46954 5.48996 8.99456 5.94245 10.3818Z",
    stroke: "#BF9A6D",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.657 6C10.657 7.37649 9.75125 8.25 8.90698 8.25C8.06271 8.25 7.15698 7.37649 7.15698 6C7.15698 4.62351 8.06271 3.75 8.90698 3.75C9.75125 3.75 10.657 4.62351 10.657 6Z",
    stroke: "#BF9A6D",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.657 6C16.657 7.37649 15.7513 8.25 14.907 8.25C14.0627 8.25 13.157 7.37649 13.157 6C13.157 4.62351 14.0627 3.75 14.907 3.75C15.7513 3.75 16.657 4.62351 16.657 6Z",
    stroke: "#BF9A6D",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0657 11.6191C20.6133 13.0064 19.4681 13.5315 18.6971 13.2428C17.9262 12.9542 17.3354 11.7792 17.7878 10.392C18.2403 9.00473 19.3854 8.47963 20.1564 8.76827C20.9274 9.0569 21.5181 10.2318 21.0657 11.6191Z",
    stroke: "#BF9A6D",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnimals);
export default __webpack_public_path__ + "static/media/animals.97d03a48016e732aaa0ee8a4672b184b.svg";
export { ForwardRef as ReactComponent };